import Sortable from "sortablejs";

export const SortableNavbar = {
  mounted() {
    this.initSortable();
  },

  updated() {
    this.initSortable();
  },

  initSortable() {
    const container = this.el;
    if (!container) return;

    if (this.sortable) {
      this.sortable.destroy();
      this.sortable = null;
    }

    if (container.dataset.disabled === "true") {
      return;
    }

    const group = container.dataset.group; // "top" or "children"
    const parentId = container.dataset.parentId;
    const hook = this;
    if (group === "top") {
      this.sortable = new Sortable(container, {
        animation: 150,
        handle: ".drag-handle",
        ghostClass: "opacity-50",
        chosenClass: "ring",
        dragClass: "shadow-lg",
        draggable: "> [data-id]",

        onEnd: (evt) => {
          if (evt.oldIndex === evt.newIndex) return;
          const ids = Array.from(
            container.querySelectorAll(":scope > [data-id]"),
          ).map((el) => el.dataset.id);
          hook.pushEvent("reorder", { ids: ids });
        },
      });
    } else if (group === "children") {
      this.sortable = new Sortable(container, {
        animation: 150,
        handle: ".drag-handle",
        ghostClass: "opacity-50",
        chosenClass: "ring",
        dragClass: "shadow-lg",
        draggable: "> [data-id]",
        group: "navbar-children", // shared group name enables cross-parent dragging

        onEnd: (evt) => {
          const fromParent = evt.from.dataset.parentId;
          const toParent = evt.to.dataset.parentId;

          if (fromParent === toParent && evt.oldIndex === evt.newIndex) return;

          if (fromParent !== toParent) {
            // Moved to a different parent
            const childId = evt.item.dataset.id;
            const newIds = Array.from(
              evt.to.querySelectorAll(":scope > [data-id]"),
            ).map((el) => el.dataset.id);
            hook.pushEvent("move_child", {
              child_id: childId,
              new_parent_id: toParent,
              ids: newIds,
            });
          } else {
            // Reorder within same parent
            const ids = Array.from(
              container.querySelectorAll(":scope > [data-id]"),
            ).map((el) => el.dataset.id);
            hook.pushEvent("reorder_children", {
              parent_id: parentId,
              ids: ids,
            });
          }
        },
      });
    }
  },

  destroyed() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  },
};
